// DatosCotizacionTabXL - Sprint 44 Fase 3 Vista 4.
// Tab datos de cotizacion. Igual patron que DatosVentaTabXL pero con
// campo `validez_dias` en vez de `condicion_pago`.
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';
import ClientePicker from '../../../components/shared/ClientePicker';
import XLSelect from '../../../components/xl/XLSelect';
import XLInput from '../../../components/xl/XLInput';

const CSS_ID = 'xl-datos-cot-css';
const CSS = `
.xl-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  font-family: var(--xl-font-sans);
}
@media (max-width: 720px) { .xl-form-grid { grid-template-columns: 1fr } }
.xl-form-grid__full { grid-column: 1 / -1 }

.xl-field { display: flex; flex-direction: column; gap: 4px }
.xl-field__label {
  font-size: 12px; font-weight: 500;
  color: var(--xl-color-text-secondary);
}
.xl-field__input {
  width: 100%;
  font: 400 14px/1.4 var(--xl-font-sans);
  color: var(--xl-color-text);
  background: var(--xl-color-bg);
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-md);
  padding: 9px 12px;
  box-sizing: border-box;
}
.xl-field__input:focus {
  outline: none;
  border-color: var(--xl-color-focus);
  box-shadow: 0 0 0 3px rgba(37,99,235,0.18);
}
[data-xl-theme="dark"] .xl-field__input:focus {
  box-shadow: 0 0 0 3px rgba(96,165,250,0.28);
}
.xl-field__input--ro {
  background: var(--xl-color-surface-alt);
  color: var(--xl-color-text-muted);
  font-family: var(--xl-font-mono);
  cursor: not-allowed;
}
.xl-field__ta {
  min-height: 88px; resize: vertical;
}
`;

const MONEDAS = ['COP', 'USD', 'EUR', 'MXN', 'ARS'].map((m) => ({ value: m, label: m }));

export default function DatosCotizacionTabXL({ form, set, isEditable }) {
  useEffect(() => { ensureKeyframes(); injectCSS(CSS_ID, CSS); }, []);

  const editable = isEditable !== false;

  return (
    <div className="xl-form-grid">
      <div className="xl-form-grid__full">
        <label className="xl-field">
          <span className="xl-field__label">Cliente *</span>
          <ClientePicker
            value={form.cliente_id}
            cliente={form.cliente}
            onChange={(id) => set('cliente_id', id)}
            onPickFull={(c) => set('cliente', {
              id: c.id, nombre: c.nombre, email: c.email, telefono: c.telefono,
            })}
          />
        </label>
      </div>

      <label className="xl-field">
        <span className="xl-field__label">Numero</span>
        <input
          className="xl-field__input xl-field__input--ro"
          value={form.numero || ''}
          readOnly
        />
      </label>

      <label className="xl-field">
        <span className="xl-field__label">Fecha</span>
        <input
          type="date"
          className="xl-field__input"
          value={form.fecha || ''}
          onChange={(e) => set('fecha', e.target.value)}
          disabled={!editable}
        />
      </label>

      <XLSelect
        label="Moneda"
        value={form.moneda || 'COP'}
        onChange={(e) => set('moneda', e.target.value)}
        options={MONEDAS}
        disabled={!editable}
      />

      <XLInput
        label="Validez (dias)"
        type="number"
        min="0"
        step="1"
        value={form.validez_dias == null ? '' : form.validez_dias}
        onChange={(e) => set('validez_dias', e.target.value)}
        disabled={!editable}
        hint="Dias de validez de la oferta desde la fecha."
      />

      <div className="xl-form-grid__full">
        <label className="xl-field">
          <span className="xl-field__label">Observaciones</span>
          <textarea
            rows={4}
            className="xl-field__input xl-field__ta"
            value={form.observaciones || ''}
            onChange={(e) => set('observaciones', e.target.value)}
            disabled={!editable}
          />
        </label>
      </div>
    </div>
  );
}
